<button
  *ngIf='route && !Click'
  [ngClass]="['UI_button', color, size, style || 'filled']"
  [routerLink]='!disabled ? route : null'>
  <ng-container *ngIf='!showLoadingIcon; else spinner'>{{ text }}</ng-container>
</button>
<button
  (click)='onButtonClick($event)'
  *ngIf='route && Click'
  [class.d-flex]='!!icon'
  [ngClass]="[
    'UI_button',
    color,
    size,
    disabled ? 'disabled' : 'primary',
    style || 'filled'
  ]"
  [routerLink]='!disabled ? route : null'>
  <ng-container *ngIf='!showLoadingIcon; else spinner'>{{ text }}</ng-container>
  <fa-icon *ngIf='icon' [icon]='icon' [size]="'1x'"></fa-icon>
</button>
<button
  (click)='onButtonClick($event)'
  *ngIf='!route && Click'
  [class.d-flex]='!!icon'
  [disabled]='disabled'
  [ngClass]="['UI_button', color, size, style || 'filled']"
  type='button'>
  <ng-container *ngIf='!showLoadingIcon; else spinner'>{{ text }}</ng-container>
  <fa-icon *ngIf='icon' [icon]='icon' [size]="'1x'"></fa-icon>
</button>
<button
  (click)='onButtonClick($event)'
  *ngIf='!route && !Click'
  [class.d-flex]='!!icon'
  [disabled]='disabled'
  [ngClass]="['UI_button', color, size, style || 'filled']"
  type='button'>
  <ng-container *ngIf='!showLoadingIcon; else spinner'>{{ text }}</ng-container>
  <fa-icon *ngIf='icon' [icon]='icon' [size]="'1x'"></fa-icon>
</button>

<ng-template #spinner>
  <mat-progress-spinner color='primary' diameter='20' mode='indeterminate'>
  </mat-progress-spinner>
</ng-template>
